import { render, staticRenderFns } from "./ungleichespaar.vue?vue&type=template&id=11061379&scoped=true&"
import script from "./ungleichespaar.vue?vue&type=script&lang=js&"
export * from "./ungleichespaar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11061379",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
